<template>
    <div id="datatable-mytips-vehicle-ktypes">
        <v-data-table
            :headers="headers"
            :items="vehicleKtypes"
            dense
            :items-per-page="-1"
            hide-default-footer
        >

        <template v-slot:[`item.name`]="{ item }">
            <span class="span-name">{{item.name}}</span>
        </template>

        <template v-slot:[`item.value`]="{ item }">
            <span class="span-value">{{item.value}}</span>
        </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        vehicleKtypes: Array | Object,
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t('backoffice.mytips.datatable.headers.field'),
                    align: "start",
                    value: "name",
                    class: "header-table-color",
                },
                {
                    text: this.$t('backoffice.mytips.datatable.headers.data'),
                    align: "start",
                    value: "value",
                    class: "header-table-color",
                },
            ],
        };
    },
    methods: {
    }
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-mytips-vehicle-ktypes {
    .status-column {
        width: 50%;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 5px;
        margin-top: 5px;
        .v-chip__content {
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
        }
    }
    .row-services {
        width: 85px;
        margin: 0 auto;
        @media (max-width: 599px) {
            display: block !important;
        }
        .service{
            @media (max-width: 599px) {
                float: left;
            }
        }
        .services {
            height: 14px !important;
            width: 14px !important;
            border-radius: 50% !important;
            font-size: 10px !important;
            padding: 2px;
        }
    }

    .circle {
        background-color: #e6e5e5;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }
    .star {
        color: #ffc117 !important;
    }

    .bold-style {
        font-weight: bold;
    }

    .v-data-footer {
        margin-right: 40px !important;
    }

    .btn-show-hours {
        width: 14rem;
        text-transform: initial;
        color: white;
        background-color: var(--v-primary-base);
    }

    tbody tr:nth-of-type(even) {
        background-color: rgba(0, 0, 0, .05);
    }

    .span-value {
        color: var(--v-primary-base);
    }

    .span-name {
        color: var(--v-primary-darken3);
    }

}
#public-btn {
    width: 14rem;
    text-transform: initial;
    color: white;
    background-color: var(--v-primary-base) !important;
}


.v-menu__content[role=menu] {
   .v-small-dialog__content {
        padding: 0 !important;
    }
}

.theme--light.v-small-dialog__actions, .theme--light.v-small-dialog__menu-content {
    left: 1110px !important;
}

@media (max-width: 1025px) {
    .theme--light.v-small-dialog__actions, .theme--light.v-small-dialog__menu-content {
        left: 780px !important;
    }
}

@media (min-width: 1450px) and (max-width: 1439px){
    .theme--light.v-small-dialog__actions, .theme--light.v-small-dialog__menu-content {
        left: 1360px !important;
    }
}

@media (min-width: 2559px) {
    .theme--light.v-small-dialog__actions, .theme--light.v-small-dialog__menu-content {
        left: 1704px !important;
    }
}

.nodrop {
    cursor: no-drop !important;
}

</style>
